<!-- 
    每日活動設定頁面
    
    新頁面 ( 每日活動設定 )：
    
    (管理者跟員工)
    
    控制前台每日活動頁面的顯示狀態
 -->

<template>
  <v-container fluid>
    <!-- 頁面說明 -->
    <v-card class="mb-6" color="blue lighten-5">
      <v-card-text>
        <v-icon color="blue" class="mr-2">mdi-information</v-icon>
        <span class="subtitle-1">用來控制前台的每日活動頁面是否顯示</span>
      </v-card-text>
    </v-card>

    <v-layout v-if="!isEdit">
      <v-spacer></v-spacer>
      <v-btn color="blue lighten-2" class="mb-4" @click="isEdit = true"
        >編輯</v-btn
      >
    </v-layout>
    
    <!-- 每日任務 -->
    <v-layout align-center class="mb-3">
      <v-switch
        v-model="settings.DAILY_TASK.enable"
        inset
        label="每日任務"
        :readonly="!isEdit"
        style="font-weight: 700"
      ></v-switch>
    </v-layout>

    <!-- 非洲拉霸 -->
    <v-layout align-center class="mb-3">
      <v-switch
        v-model="settings.AFRICA_SLOT.enable"
        inset
        label="非洲拉霸"
        :readonly="!isEdit"
        style="font-weight: 700"
      ></v-switch>
    </v-layout>

    <!-- 世界Boss -->
    <v-layout align-center class="mb-3">
      <v-switch
        v-model="settings.WORLD_BOSS.enable"
        inset
        label="世界Boss"
        :readonly="!isEdit"
        style="font-weight: 700"
      ></v-switch>
    </v-layout>

    <!-- 紅利火箭 -->
    <v-layout align-center class="mb-3">
      <v-switch
        v-model="settings.BONUS_ROCKET.enable"
        inset
        label="紅利火箭"
        :readonly="!isEdit"
        style="font-weight: 700"
      ></v-switch>
    </v-layout>

    <v-layout v-if="isEdit" class="mt-6">
      <v-spacer></v-spacer>
      <v-btn color="blue-grey lighten-4" class="" @click="cancel()">取消</v-btn>
      <v-btn color="green lighten-2" class="ml-3" @click="saveSetting()"
        >儲存</v-btn
      >
    </v-layout>
  </v-container>
</template>

<script>
import common from "@/mixins/common";
// import { mapActions } from "vuex";
export default {
  name: "dailyActivitySettings",
  mixins: [common],
  data() {
    return {
      isEdit: false,
      settings: {
        // 每日任務
        DAILY_TASK: {
          enable: false,
        },
        // 非洲拉霸
        AFRICA_SLOT: {
          enable: false,
        },
        // 世界Boss
        WORLD_BOSS: {
          enable: false,
        },
        // 紅利火箭
        BONUS_ROCKET: {
          enable: false,
        },
      },
    };
  },
  watch: {},
  methods: {
    // ...mapActions(["getDailyActivitySetting", "saveDailyActivitySetting"]),

    // 載入資料
    async loadData() {
      try {
        this.loading = true;
        const res = await this.getDailyActivitySetting();
        if (res.data.statusCode === 0) {
          console.log(`getDailyActivitySetting ${JSON.stringify(res.data)}`);
          const data = res.data.data;

          // 將資料轉換為以 activityId 為鍵的物件
          data.forEach((item) => {
            if (this.settings[item.activityId]) {
              this.settings[item.activityId].enable = item.enable;
            }
          });
        }
      } catch (e) {
        this.loading = false;
        console.log(`getDailyActivitySetting error`, e.stack);
      } finally {
        this.loading = false;
      }
    },
    // 儲存
    async saveSetting() {
      console.log(`saveSetting data = ${JSON.stringify(this.settings)}`);

      try {
        this.loading = true;

        // 將 settings 物件轉換回原始的資料格式
        const data = Object.entries(this.settings).map(
          ([activityId, setting]) => ({
            activityId,
            ...setting,
          })
        );

        console.log(`saveDailyActivitySetting ${JSON.stringify(data)}`);

        const res = await this.saveDailyActivitySetting(data);

        if (res.data.statusCode === 0) {
          console.log(`saveDailyActivitySetting ${JSON.stringify(res.data)}`);

          // this.loadData();
          this.isEdit = false;
          
          this.showAlert({
            title: '成功',
            content: '每日活動設定已儲存',
            showCancel: false,
            confirmEvent: () => {
              this.hideAlert();
            }
          });
        }
      } catch (e) {
        this.loading = false;
        console.log(`saveDailyActivitySetting error`, e.stack);
        this.showAlert({
          title: '錯誤',
          content: '儲存失敗，請稍後再試',
          showCancel: false,
          confirmEvent: () => {
            this.hideAlert();
          }
        });
      } finally {
        this.loading = false;
      }

      this.isEdit = false;
    },
    // 取消
    cancel() {
      this.isEdit = false;
      // this.loadData();
    },
  },
  //  頁面載入時加載資料
  created() {
    // this.loadData();
  },
};
</script>

<style scoped></style>
